import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactsComponent } from './list/contacts.component';
import { ContactsRoutingModule } from './contacts-routing.module';

import { ContactsProfileComponent } from './contacts-profile/contacts-profile.component';

import { ContactsProfileHeadComponent } from './contacts-profile/contacts-profile-head/contacts-profile-head.component';
import { SharedModule } from '../../../shared/shared.module';
import { ListsModule } from 'src/app/features/lists/lists.module';
import { MediaLibraryModule } from 'src/app/features/media-library/media-library.module';

@NgModule({
  imports: [CommonModule, SharedModule, ContactsRoutingModule, ListsModule],
  declarations: [
    ContactsComponent,
    ContactsProfileComponent,
    ContactsProfileHeadComponent,
  ],
  exports: [],
})
export class ContactsModule {}
